import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { TasksRoutingModule } from "./tasks-routing.module";
import { TaskTypesModule } from '../tasks/task-types/task-types.module';

import { SharedModule } from "../shared/shared.module";

import { TaskManageComponent } from './task-manage/task-manage.component';
import { TasksComponent } from './tasks.component';

import { CalendarModule, DropdownModule, MultiSelectModule, GMapModule } from 'primeng/primeng';

@NgModule({
  declarations: [
    TasksComponent,
    TaskManageComponent
  ],
  imports: [
    SharedModule,
    TasksRoutingModule,
    TaskTypesModule,
    ReactiveFormsModule,
    CalendarModule,
    BrowserAnimationsModule,
    DropdownModule,
    GMapModule
  ],
})
export class TasksModule { }
